<p class="mb-0" kui-list-item-text>
    <strong>{{ name }}</strong>
    <kui-icon
        *ngIf="isPinned"
        class="muted icon ml-1 text-center"
        name="thumbtack">
    </kui-icon>
</p>

<div class="d-flex ml-auto value" kui-list-item-text>
    <p class="mb-0">
        {{ value }}
    </p>
    <kui-icon
        kui-action
        *ngIf="isMobile"
        class="icon ml-2 text-center"
        name="ellipsis"
        [title]="'STATUS.DETAILS.SIDEBAR.ACTIONS.CLOSE' | translate">
    </kui-icon>
    <kui-dropdown
        #contextMenuRef
        class="context-menu"
        [style]="'none'"
        [menu]="contextMenu">
    </kui-dropdown>
</div>